if (process.env.NODE_ENV === 'development') {
  /*ENABLE ME FOR PERFORMANCE DEBUGGING - CHECKS FOR NEEDLESS RERENDERS*/ 
  // const whyDidYouRender = require('@welldone-software/why-did-you-render');
  // whyDidYouRender(React, {
  //   trackAllPureComponents: true,
  // });
}